import { Box } from '@mui/material';

const PositionSlotValidationErrorsTooltip = ({ errors }: { errors: string[] }) => (
  <Box component="ul" sx={{ m: 0, pl: 2 }}>
    {errors.map(error => (
      <Box component="li" key={error}>
        {error}
      </Box>
    ))}
  </Box>
);

export default PositionSlotValidationErrorsTooltip;
